import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "./Components/theme/ThemeProvider";
import { Provider } from "react-redux";
import store from "./Components/hooks/Redux/store";
import { Toaster } from "react-hot-toast";
// import { FilterProvider } from "@11solutionspvtltd/eleven-solutions-trust-website";
import FilterProvider from "./Components/admin/FilterContext";
import DonationFilterProvider from "./Components/admin/donationdetails/DonationFilterContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <DonationFilterProvider>
      <FilterProvider>
        <ThemeProvider>
          <Provider store={store}>
            <App />
            <Toaster />
          </Provider>
        </ThemeProvider>
      </FilterProvider>
    </DonationFilterProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
